








import { Prefix } from "@/types/debug-mode";
import { Features } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component
export default class PrefixesAddToggle extends Vue {
  @State(state => state.debugMode.prefixes) prefixes!: Prefix[] | null;
  @State(state => state.debugMode.showAddPrefix) showAddPrefix!: boolean;

  @Getter("settings/activeCacheFeatures") features!: Features;

  get buttonClass() {
    return this.showAddPrefix ? "" : "button-primary";
  }

  get icon() {
    return this.showAddPrefix ? "close" : "plus";
  }

  get title() {
    return this.showAddPrefix ? "Cancel" : "Watch Prefix";
  }

  get prefixLimitReached() {
    const prefixLimit = this.features["prefix-limit"] as number;
    return this.prefixes && this.prefixes.length >= prefixLimit;
  }

  toggle() {
    this.$emit("toggle");
  }
}
